import { Outlet } from "react-router";

function Apps({ session }) {
  return (
    <div id="apps-container" className="w-full overflow-auto overflow-x-hidden">
      <Outlet context={{ session }} />
    </div>
  );
}

export default Apps;
